// ✅ customizer-ui.js (REN) — endast preview rendering
// Inget progress, inga steg, inga priser, inga val.

document.addEventListener("DOMContentLoaded", () => {
  const previewGrid = document.getElementById("preview-grid");
  const nextBtn = document.getElementById("next-from-upload");

  if (!previewGrid) return;

  function redraw(images) {
    previewGrid.innerHTML = "";

    (images || []).forEach((src, index) => {
      const wrap = document.createElement("div");
      wrap.className = "preview-thumb";

      const img = document.createElement("img");
      img.src = src;
      img.alt = "Uploaded photo";

      const btn = document.createElement("button");
      btn.className = "preview-remove";
      btn.type = "button";
      btn.textContent = "×";
      btn.dataset.index = String(index);

      wrap.appendChild(img);
      wrap.appendChild(btn);
      previewGrid.appendChild(wrap);
    });

    // NOTE: vi rör INTE disabled-state här,
    // customizer.js styr exakt-regeln (min/max antal bilder).
  }

  // customizer.js anropar denna och skickar in en array av image srcs
  window.updatePreviewUI = function(images) {
    redraw(images || []);

    // valfritt: om du vill att NEXT aldrig ska “låsa upp” här
    // (customizer.js sköter det), så rör vi inte nextBtn alls.
  };

  // Klick på X -> be customizer.js ta bort bilden
  previewGrid.addEventListener("click", (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    if (!target.classList.contains("preview-remove")) return;

    const idx = Number(target.dataset.index);
    if (Number.isNaN(idx)) return;

    // customizer.js har redan egen remove-handler,
    // men om den inte körs av någon anledning kan vi “fallbacka”:
    if (typeof window.removeUploadedImageAtIndex === "function") {
      window.removeUploadedImageAtIndex(idx);
    }
  });
});
